import { render } from "./CreateTMC.vue?vue&type=template&id=921ff430&scoped=true&ts=true"
import script from "./CreateTMC.vue?vue&type=script&lang=ts"
export * from "./CreateTMC.vue?vue&type=script&lang=ts"

import "./CreateTMC.vue?vue&type=style&index=0&id=921ff430&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-921ff430"]])

export default __exports__